'use client';

import { localeAtom } from '@core/Atoms/Locale/Locale.atom';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import { mapFiltersForDisplay } from '@core/Utils/SearchFilters/MapFiltersForDisplay';
import { Filter } from '@gds/Icons/Paths/Filter';
import { Sort } from '@gds/Icons/Paths/Sort';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';

import { filterTrayOpenAtom } from 'Atoms/App/Plp/FilterTrayOpenAtom';
import { sortDrawerOpenAtom } from 'Atoms/App/Plp/SortDrawerOpenAtom';

import styles from './Toolbar.module.css';

interface ToolbarProps {
  strings: {
    filtersBtn: string;
    sortBtn: string;
  };
  belowBreadcrumbs?: boolean;
  hideSort?: boolean;
}

export const Toolbar = ({ strings, belowBreadcrumbs, hideSort }: ToolbarProps) => {
  const [isFiltersOpen, setIsFiltersOpen] = useAtom(filterTrayOpenAtom);
  const filtersList = useAtomValue(filtersListAtom);
  const locale = useAtomValue(localeAtom);
  const areaFilter = filtersList.find(filter => filter.id === 'area');
  const regionFilter = filtersList.find(filter => filter.id === 'region');
  const dealershipFilter = filtersList.find(filter => filter.id === 'dealership-id');

  let filtersLength = mapFiltersForDisplay(filtersList, locale).length;

  if (areaFilter) {
    filtersLength -= 3;
  } else if (regionFilter || dealershipFilter) {
    filtersLength -= 2;
  }

  const openSortDrawer = useSetAtom(sortDrawerOpenAtom);

  return (
    <div className={`${belowBreadcrumbs && styles.borderTop} ${styles.toolbarWrapper}`}>
      <button
        onClick={() => {
          setIsFiltersOpen(!isFiltersOpen);
        }}
        data-test-id="filter-menu"
        className="typography-subheading-3"
      >
        <Filter /> {strings.filtersBtn} {filtersLength > 0 && ` (${filtersLength})`}
      </button>
      <span />
      {!hideSort && (
        <button className="typography-subheading-3" onClick={() => openSortDrawer(true)}>
          <Sort /> {strings.sortBtn}
        </button>
      )}
    </div>
  );
};
